
import { Check } from "lucide-react";
import { useCrefazContext } from "@/app/contexts/CrefazContext";
import masks from "@/app/utils/masks";
import { Button } from "@/view/components/ui/button";

interface ProposalSuccessProps {
  visible?: boolean;
  onClose: () => void;
}

export default function ProposalSuccess({ visible, onClose }: ProposalSuccessProps) {
  const { customerData, proposalData } = useCrefazContext();

  if (!visible) return null;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
          <Check className="h-8 w-8 text-green-600" />
        </div>
        <div>
          <h2 className="text-2xl font-semibold text-black01">Proposta realizada!</h2>
          <p className="mt-2 text-sm text-gray-500">
            Sua proposta foi registrada com sucesso. Você pode acompanhar o status através do seu dashboard.
          </p>
        </div>
      </div>

      <div className="rounded-xl border bg-gray-50 p-4">
        <p className="text-sm font-medium text-gray-500">Valor</p>
        <h3 className="text-2xl font-bold text-black01">
          {masks.currency(proposalData?.value || 0)}
        </h3>
        
        <div className="mt-2 flex items-center gap-1 text-sm">
          <span className="text-gray-500">Para</span>
          <span className="font-semibold text-black01">{customerData?.name}</span>
        </div>
      </div>

      <Button 
        className="w-full rounded-full bg-primary font-bold text-white hover:bg-primary/90"
        onClick={onClose}
      >
        Voltar para o início
      </Button>
    </div>
  );
}
